import React, { useState, useEffect, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
// const isTestEnv = process.env.REACT_APP_TEST_ENV;

const Sidebar = ({ isCollapsed, setIsCollapsed }) => {
  const [openSettings, setOpenSettings] = useState(false);
  // NEW: Tracks if the user manually closed the leave menu to override URL auto-expansion
  // const [openLeaveManagement, setOpenLeaveManagement] = useState(false);
  // const [explicitlyClosedLeave, setExplicitlyClosedLeave] = useState(false);
  
  // Existing explicit closure for settings
  const [explicitlyClosed, setExplicitlyClosed] = useState(false);
  const location = useLocation();
  
  const role = localStorage.getItem('role')?.toLowerCase();
  const isAdmin = role === 'admin' || role === 'super admin';

  // Routes for submodules wrapped in useMemo to fix exhaustive-deps warning
  const leaveRoutes = useMemo(() => ['/leave-management/request', '/leave-management/approval'], []);

  // Reset explicit closures when navigating away from those modules
  useEffect(() => {
    const adminRoutes = ['/branch', '/department', '/client', '/job-title', '/users', '/role','/leave-type','/leave-config', '/sync-sched', '/storageConfig', '/importLogs', '/auditLogs', '/masterData'];
    if (!adminRoutes.includes(location.pathname)) {
      setExplicitlyClosed(false);
    }
    if (!leaveRoutes.includes(location.pathname) && location.pathname !== '/leave-management') {
      // setExplicitlyClosedLeave(false);
    }
  }, [location.pathname, leaveRoutes]);

  const linkStyle = (path) => {
    const isActive = location.pathname === path;
    return {
      textDecoration: 'none',
      color: isActive ? '#ffffff' : '#94a3b8',
      padding: '12px 15px',
      borderRadius: '8px',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
      backgroundColor: isActive ? '#3b82f6' : 'transparent',
      fontSize: '0.85rem',
      fontWeight: isActive ? '600' : '500',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      marginBottom: '4px',
      boxShadow: isActive ? '0 4px 12px rgba(59, 130, 246, 0.3)' : 'none'
    };
  };

  const subLinkStyle = (path) => {
    const isActive = location.pathname === path;
    return {
      ...linkStyle(path),
      backgroundColor: isActive ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
      padding: '10px 15px',
      fontSize: '0.8rem',
      boxShadow: 'none',
      borderLeft: isActive ? '3px solid #3b82f6' : '3px solid transparent',
      borderRadius: '0 8px 8px 0',
      color: isActive ? '#ffffff' : '#94a3b8',
    };
  };

  // Visibility logic for dropdowns
  const adminRoutes = ['/branch', '/department', '/client', '/job-title', '/users', '/role', '/sync-sched', 
    // '/leave-type',
    // '/leave-config',
     '/storageConfig', '/importLogs', '/auditLogs', '/masterData'];
  const isMenuOpen = !explicitlyClosed && (openSettings || adminRoutes.includes(location.pathname));
  // const isLeaveMenuOpen = !explicitlyClosedLeave && (openLeaveManagement || leaveRoutes.includes(location.pathname));

  return (
    <div style={{
      height: '100%',
      width: '100%',
      padding: isCollapsed ? '20px 8px' : '20px 12px',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.3s',
      overflowY: 'auto', 
      overflowX: 'hidden',
      backgroundColor: '#0f172a'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: isCollapsed ? 'center' : 'space-between', marginBottom: '20px', padding: '0 8px' }}>
        {!isCollapsed && <span style={{ color: '#64748b', fontSize: '0.7rem', fontWeight: '700', textTransform: 'uppercase' }}>Main Navigation</span>}
        <button type="button" onClick={() => setIsCollapsed(!isCollapsed)} className="btn p-1 d-flex align-items-center justify-content-center" style={{ background: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)', color: '#94a3b8', borderRadius: '6px', width: '28px', height: '28px' }}>
          <i className={`bi bi-chevron-${isCollapsed ? 'right' : 'left'}`}></i>
        </button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Link to="/dashboard" style={linkStyle('/dashboard')}>
          <i className="bi bi-grid-1x2"></i> {!isCollapsed && <span>Dashboard</span>}
        </Link>
        
        <Link to="/employee" style={linkStyle('/employee')}>
          <i className="bi bi-people"></i> {!isCollapsed && <span>Employees</span>}
        </Link>

        {/* Leave Management Collapsible Module */}
        {/* <div style={{ marginTop: '2px' }}>
          <div 
            onClick={(e) => {
              e.stopPropagation();
              if (!isCollapsed) {
                const newState = !isLeaveMenuOpen;
                setOpenLeaveManagement(newState);
                setExplicitlyClosedLeave(!newState);
              }
            }}
            style={{ ...linkStyle('#'), cursor: isCollapsed ? 'default' : 'pointer', backgroundColor: 'transparent', boxShadow: 'none', color: '#94a3b8', marginBottom: '0px' }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
              <i className="bi bi-calendar-check"></i>
              {!isCollapsed && <span>Leave Management</span>}
            </div>
            {!isCollapsed && (
              <span style={{ fontSize: '0.7rem', opacity: 0.8 }}>
                 <i className={`bi bi-chevron-${isLeaveMenuOpen ? 'up' : 'down'}`}></i>
              </span>
            )}
          </div>

          {isLeaveMenuOpen && !isCollapsed && (
            <div style={{ marginLeft: '20px', marginTop: '2px', borderLeft: '1px solid #334155', display: 'flex', flexDirection: 'column', paddingLeft: '5px' }}>
                <Link to="/leave-management" style={subLinkStyle('/leave-management')}>
                Employee
              </Link>
              <Link to="/leave-management/request" style={subLinkStyle('/leave-management/request')}>
                Leave Requests
              </Link>
              <Link to="/leave-management/approval" style={subLinkStyle('/leave-management/approval')}>
                Leave Approval
              </Link>
            </div>
          )}
        </div> */}

        {isAdmin && (
          <div style={{ marginTop: '10px' }}>
            <div 
              onClick={(e) => {
                e.stopPropagation();
                if (!isCollapsed) {
                  const newState = !isMenuOpen;
                  setOpenSettings(newState);
                  setExplicitlyClosed(!newState);
                }
              }}
              style={{ ...linkStyle('#'), cursor: isCollapsed ? 'default' : 'pointer', backgroundColor: 'transparent', boxShadow: 'none', color: '#94a3b8' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
                <i className="bi bi-shield-lock"></i>
                {!isCollapsed && <span>Administration</span>}
              </div>
              {!isCollapsed && (
                <span style={{ fontSize: '0.7rem', opacity: 0.8 }}>
                   <i className={`bi bi-chevron-${isMenuOpen ? 'up' : 'down'}`}></i>
                </span>
              )}
            </div>

            {isMenuOpen && !isCollapsed && (
              <div style={{ marginLeft: '20px', marginTop: '5px', borderLeft: '1px solid #334155', display: 'flex', flexDirection: 'column', paddingLeft: '5px' }}>
                {adminRoutes.map(route => (
                    <Link key={route} to={route} style={subLinkStyle(route)}>
                        {route.replace('/', '').replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                    </Link>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;